<!-- @format -->

<div class="validation-errors" [attr.aria-live]="ariaLive ? 'assertive' : 'off'" data-cy="validation-errors">
  @if (validationErrors$ | async; as validationErrors) {
    @if (
      (validationErrors.errors?.length > 0 || validationErrors.hasChildErrors) &&
      (!control || (control.invalid && (control.touched || control.dirty)))
    ) {
      <div class="row">
        <div class="col-12">
          <div sisFocusableError class="error-list" [id]="formFieldId ? formFieldId + '_errors' : null">
            @for (error of validationErrors.errors; track error) {
              <p class="error-list__item" data-cy="validation-error">
                {{ error.translationKey | translate: error.translationParams }}
              </p>
            }
            <ng-content select="p"></ng-content>
          </div>
        </div>
      </div>
    }
  }
</div>
